import HomeTemplate from "components/templates/HomeTemplate/HomeTemplate";

export default function HomePage() {
  return <HomeTemplate />;
}
